import { FormGroup, FormArray } from '@angular/forms';
import { Injectable } from '@angular/core';

@Injectable()
export class FormValidationService {

    // get all values of the formGroup, loop over them
    // then mark each field as touched
    public markFormGroupTouched(formGroup: FormGroup) {
        Object.keys(formGroup.controls).forEach(control => {
            const cntrl = formGroup.get(control);
            if (cntrl) {
                cntrl.markAsTouched();
            }
            if (formGroup.get(control) instanceof FormGroup || formGroup.get(control) instanceof FormArray) { // if nested
                this.markFormGroupTouched(formGroup.get(control) as FormGroup);
            }
        });
    }

    public markFormGroupUntouched(formGroup: FormGroup) {
        Object.keys(formGroup.controls).forEach(control => {
            const cntrl = formGroup.get(control);
            if (cntrl) {
                cntrl.markAsUntouched();
            }
            if (formGroup.get(control) instanceof FormGroup || formGroup.get(control) instanceof FormArray) { // if nested
                this.markFormGroupUntouched(formGroup.get(control) as FormGroup);
            }
        });
    }
}
